import Box from "@mui/material/Box";
import { observer } from "mobx-react-lite";
import React from "react";
import MultiSelector, { MultiSelectorOptionInterface } from "../../../../components/selectors/MultiSelector";
import i18nStore from "../../../../i18n/store";
import filterStore from "../filters/filtersStore";
import BaseResultTable, { BaseCalculationsTablePropsProps } from "./BaseResultTable";
import useMuiCalculationsBranchesColDefs from "./useMuiCalculationsBranchesColDefs";
import { ParamType } from "../../enums";


interface ResultBranchesTableProps extends BaseCalculationsTablePropsProps {}
const ResultBranchesTable = observer((props: ResultBranchesTableProps) => {
    const translations = i18nStore.getTranslations;

    const columnDefs = useMuiCalculationsBranchesColDefs(filterStore.getNodes);

    return (
        <BaseResultTable
            table="branches"
            colDefs={columnDefs}
            rows={props.rows}
            loading={props.loading}
            extraToolbar={
                <Box>
                    <MultiSelector
                        values={filterStore.getBranchValueTypes}
                        setValues={(vals) => filterStore.setBranchValueTypes(vals)}
                        options={[
                            {tooltipText: translations.paramType.currents, label: ParamType.Current.name, value: ParamType.Current.name},
                            {tooltipText: translations.paramType.powers, label: ParamType.Power.name, value: ParamType.Power.name},
                            {tooltipText: translations.paramType.resistances, label: ParamType.Resistance.name, value: ParamType.Resistance.name},
                        ] as MultiSelectorOptionInterface[]}
                    />
                </Box>
            }
        />
    );
});

export default ResultBranchesTable;
